import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  workspace: {
    display: "grid",
    alignItems: "start",
    gap: theme.design.space.lg,
    minWidth: 0,
    width: "100%",
    "& > *": { minWidth: 0 },
  },
  market: {
    gridTemplateColumns: "minmax(0, 1fr) minmax(260px, .42fr)",
    [theme.breakpoints.down("lg")]: { gridTemplateColumns: "minmax(0, 1fr)" },
  },
  travel: {
    gridTemplateColumns: "minmax(0, 1fr)",
  },
}));

const ActivityWorkspace = ({
  variant,
  children,
}: {
  variant: "market" | "travel";
  children: ReactNode;
}) => {
  const { classes, cx } = useStyles();
  return <Box className={cx(classes.workspace, classes[variant])}>{children}</Box>;
};

export default ActivityWorkspace;
